import React, { useEffect, useState } from 'react';
import API_BASE_URL from "Components/API";
import Loading from "Components/Loading";
import { useTranslation } from "react-i18next";
import axios from 'axios';
import parse from 'html-react-parser';
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
import { ReactComponent as DerivativeMarket } from "Assets/icons/derivativeMarket.svg";
import { ReactComponent as PowerMarket } from "Assets/icons/powerMarket.svg";
import { ReactComponent as PhysicalMarket } from "Assets/icons/physicalMarket.svg";
import { ReactComponent as OtherTradableSecurities } from "Assets/icons/otherTradableSecurities.svg";
import { ReactComponent as LogoGray } from "Assets/icons/logo-gray.svg";
const TradesFee = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    return (
        <div className="megaMenuContent">
            <div className="row h-100">
                <div className="col-4 d-flex justify-content-center align-items-center">
                    <a href="/TradesFee/#physical-power" className="tradesFeeItems py-2 px-4 w-100 text-center">
                        <PowerMarket
                            className="max-width-100 mx-2 d-inline-block"
                        />
                        <PhysicalMarket
                            className="max-width-100 mx-2 d-inline-block"
                        />

                        {t('fees_physical_and_power') }
                    </a>
                </div>
                <div className="col-4 d-flex justify-content-center align-items-center">
                    <a href="/TradesFee/#derivative-market" className="tradesFeeItems py-2 px-4 w-100 text-center">
                        <DerivativeMarket
                            className="max-width-100 mx-2 d-inline-block"
                        />
                        {t('fees_derivatives_market')}
                    </a>
                </div>
                <div className="col-4 d-flex justify-content-center align-items-center">
                    <a href="/TradesFee/#other-securities" className="tradesFeeItems py-2 px-4 w-100 text-center">
                        <OtherTradableSecurities
                            className="max-width-100 mx-2 d-inline-block"
                        />
                        {t('fees_other_securities_market')}
                    </a>
                </div>
                <div className="col-12 text-start mt-2 align-self-end">
                    <a href="/TradesFee" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1" >
                        {t('view_all_fees')}
                        <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                            {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}
                        </span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default TradesFee;
